import { render, staticRenderFns } from "./PeOptionCard.vue?vue&type=template&id=1ee49be7&"
import script from "./PeOptionCard.vue?vue&type=script&lang=js&"
export * from "./PeOptionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports